import { useParams, useLocation } from "react-router-dom";
import { useAppData } from "../../../common/hooks/useAppData";
import { ICompanyAppData } from "../../../common/redux/reducers/appDataReducer";
import { useEffect, useState } from "react";
import {
  ApiClientDto,
  PublicApiRedirectionRequestApiFactory,
  PublicApiRedirectionProxyCredentialsDto,
  PublicApiClientApiFactory,
} from "../../../common/data/service-proxies";
import {
  useAxiosBaseURL,
  useAxiosInstance,
} from "../../../common/hooks/useAxiosInstance";
import { Error, Loading, Title, useTranslate } from "react-admin";
import { Card, CardContent } from "@material-ui/core";

const ViewRedirectApiClient = () => {
  const translate = useTranslate();
  const { id } = useParams<{ id: string }>();
  const axios = useAxiosInstance();
  const baseURL = useAxiosBaseURL();
  const location = useLocation();
  const [data, setData] = useState<ApiClientDto>();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>();
  const [proxyCredentials, setProxyCredentials] = useState<
    PublicApiRedirectionProxyCredentialsDto
  >();
  const [proxyCredentialsLoading, setProxyCredentialsLoading] = useState(false);
  const redirectionId = new URLSearchParams(location.search).get(
    "redirectionId"
  );

  const companies = useAppData((state) => state.companies);

  const getCompanyName = (id?: number | null) => {
    return (
      companies?.find((item: ICompanyAppData) => item.id === id)?.name ?? "-"
    );
  };

  useEffect(() => {
    if (!redirectionId) {
      return;
    }

    if (!axios) {
      return;
    }

    setLoading(true);
    PublicApiClientApiFactory(undefined, baseURL, axios)
      .apiAppPublicapiclientIdGet(id)
      .then((response) => {
        setData(response.data);
      })
      .catch((err) => setError(err))
      .finally(() => setLoading(false));
  }, [axios, baseURL, id, redirectionId]);

  useEffect(() => {
    if (!redirectionId) {
      return;
    }

    if (!axios) {
      return;
    }

    if (!baseURL) {
      return;
    }

    setLoading(true);
    PublicApiRedirectionRequestApiFactory(undefined, baseURL, axios)
      .apiAppPublicapiredirectionrequestProxycredentialsRedirectionIdGet(
        redirectionId
      )
      .then((response) => {
        setProxyCredentials(response.data);
      })
      .catch((err) =>
        console.error("Failed to get redirected API client: ", err)
      )
      .finally(() => setProxyCredentialsLoading(false));
  }, [axios, baseURL, redirectionId]);

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <Error error={error} />;
  }

  return (
    <div
      style={{
        marginTop: "24px",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        gap: "16px",
      }}
    >
      <Title title="resources.admin-api-clients.labels.view" />
      <Card>
        <CardContent>
          <div style={{ display: "flex", flexDirection: "row", gap: "24px" }}>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "16px" }}
            >
              <p>{translate("resources.admin-api-clients.labels.name")}:</p>
              <p>{translate("resources.admin-api-clients.labels.company")}:</p>
              <p>{translate("resources.admin-api-clients.labels.clientId")}:</p>
              <p>{translate("resources.admin-api-clients.labels.apiKey")}:</p>
            </div>
            <div
              style={{ display: "flex", flexDirection: "column", gap: "16px" }}
            >
              <p>{data?.name}</p>
              <p>{getCompanyName(data?.companyId)}</p>
              <p>
                {proxyCredentialsLoading
                  ? "Loading..."
                  : proxyCredentials?.proxyClientId ?? "-"}{" "}
              </p>
              <p>
                {proxyCredentialsLoading
                  ? "Loading..."
                  : proxyCredentials?.proxyClientSecret ?? "-"}
              </p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ViewRedirectApiClient;
